import { useTranslation } from '@lt/localization';
import React from 'react';
import type { CurrencyType } from 'src/utils/stringUtils';
import type { AdjacentTour as AdjacentTourType } from '../../types';
import AdjacentTour from './components/AdjacentTour';

import styles from './hotelCardAdjacentTours.module.css';

type HotelCardAdjacentToursProps = {
  isFlexDates: boolean;
  isHotelOnly: boolean;
  adjacentTours: AdjacentTourType[];
  currencyCode: CurrencyType;
  isMobile: boolean;
};

const HotelCardAdjacentTours: React.FC<HotelCardAdjacentToursProps> = ({
  isHotelOnly,
  adjacentTours,
  currencyCode,
  isMobile,
  isFlexDates,
}) => {
  const { t } = useTranslation();

  if (!adjacentTours.length || !isFlexDates) return null;

  const offerType = isHotelOnly
    ? t('hotelcard.dates.offerTypeHotels')
    : t('hotelcard.dates.offerTypeTours');

  return (
    <div
      className={`${styles.adjacentTours} ${
        isMobile ? styles.adjacentToursMobile : ''
      }`}
    >
      <p className={styles.title}>
        {t('hotelcard.dates.title', { offerType })}
      </p>
      <div className={styles.toursContainer}>
        {adjacentTours.map((tour) => (
          <AdjacentTour
            key={tour.tourId}
            currencyCode={currencyCode}
            isHotelOnly={isHotelOnly}
            {...tour}
          />
        ))}
      </div>
    </div>
  );
};

export default HotelCardAdjacentTours;
